import styled from 'styled-components';

export const Content = styled.p`
  text-align: center;
  margin: 30px 0 30px 0;
  font-family: lato;
`;
export const Controls = styled.div`
  display: flex;
  justify-content: flex-end;

  .MuiButton-root:first-child {
    margin-right: 10px !important;
  }
`;

export const ContentWrapper = styled.div`
  padding: 0 20px 24px 30px !important;
`;
